module.exports = __webpack_public_path__ + "img/customer_4_de.8c226c2c.png";